// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './MatchButton.scss';
import CircleLoader from '../../Util/CircleLoader/CircleLoader';

@observer class MatchButton extends Component<any, any> {

	componentDidMount() {
		if(this.props.onMount) {
			this.props.onMount();
		}
	}

	render() {
		return (
			<div className={this.props.loading ? "match-button-wrapper loading" : "match-button-wrapper"}>
				<button  
					className={this.props.className ? this.props.className : ''} 
					onClick={this.props.onClick}>{this.props.text}</button>
				{this.props.loading ? 
					<CircleLoader color='#fff' size={25} />
				: null}
			</div>
		)
	}
}

export default MatchButton;

